export default "__VITE_ASSET__LTnbtKYj__"